import {useApi} from "./useApi";
import {useFetching} from "./system/useFetching";
import {dispatcher} from "../store";  // Is this needed?
import {useEffect} from "react";
import {useStoreSelector} from "./redux/useStoreSelector";

export function useLogo() {
    const {api, isAuth} = useApi(),
      {withFetching} = useFetching()
    const logo = useStoreSelector( s => s.system.logo );

    useEffect(() => {
      if (isAuth) {
        withFetching(api.getLogo({}))
          .then( res => {
            if (res.status === 200) {
              dispatcher.system.setLogo(res.body['logo'])
            }
          })
      }
    }, [api, isAuth, withFetching])

    return {logo}
  }
